export const MAP_HOVER_CARD_GAP = 12
export const MAP_HOVER_CARD_BOUNDARY_PADDING = 16

export type MapHoverCardBoundary = {
  bottom: number
  left: number
  right: number
  top: number
}

export type MapHoverCardPlacement = {
  left: number
  placement: 'above' | 'below'
  top: number
}

export function getMapHoverCardBoundary(anchor: HTMLElement): MapHoverCardBoundary {
  const boundaryElement =
    anchor.closest('.locations-map-section') ?? anchor.closest('[data-locations-map-section]')

  const padding = MAP_HOVER_CARD_BOUNDARY_PADDING

  if (boundaryElement) {
    const rect = boundaryElement.getBoundingClientRect()
    return {
      top: rect.top + padding,
      left: rect.left + padding,
      right: rect.right - padding,
      bottom: rect.bottom - padding,
    }
  }

  return {
    top: padding,
    left: padding,
    right: window.innerWidth - padding,
    bottom: window.innerHeight - padding,
  }
}

export function resolveMapHoverCardPlacement(args: {
  anchorRect: DOMRect
  boundary: MapHoverCardBoundary
  cardRect: DOMRect
}): MapHoverCardPlacement {
  const { anchorRect, boundary, cardRect } = args
  const gap = MAP_HOVER_CARD_GAP

  const anchorCenterX = anchorRect.left + anchorRect.width / 2
  const cardWidth = cardRect.width
  const cardHeight = cardRect.height
  const halfWidth = cardWidth / 2

  const spaceAbove = anchorRect.top - gap - boundary.top
  const spaceBelow = boundary.bottom - anchorRect.bottom - gap

  let placement: 'above' | 'below' = 'above'
  if (spaceAbove < cardHeight && spaceBelow > spaceAbove) {
    placement = 'below'
  } else if (spaceAbove < cardHeight && spaceBelow <= spaceAbove) {
    placement = 'above'
  }

  let left = anchorCenterX
  if (cardWidth > 0) {
    left = Math.max(boundary.left + halfWidth, Math.min(boundary.right - halfWidth, left))
  }

  let top: number
  if (placement === 'above') {
    top = anchorRect.top - gap
    const cardTop = top - cardHeight
    if (cardTop < boundary.top) {
      top = Math.min(anchorRect.top - gap, boundary.top + cardHeight)
    }
  } else {
    top = anchorRect.bottom + gap
    if (top + cardHeight > boundary.bottom) {
      top = Math.max(anchorRect.bottom + gap, boundary.bottom - cardHeight)
    }
  }

  return { left, top, placement }
}
